export default __webpack_public_path__ + "static/media/tl-nft.71698221.png";